import React from 'react';

export default function renderNewlinesAsJsxBreaks(text) {
  if (!text || !text.split) {
    return text;
  }
  const lines = text.split(/\r?\n/);
  let i = 1;
  let key = 1;
  while (i < lines.length) {
    const br = <br key={key} />;
    key += 1;
    if (lines[i - 1]) {
      lines.splice(i, 0, br);
      i += 2;
    } else {
      lines[i - 1] = br;
      i += 1;
    }
  }
  if (!lines[i - 1]) {
    lines.pop();
  }
  if (lines.length === 1) {
    return lines[0];
  }
  return lines;
}
